import { Redirect } from "react-router-dom";
import {useTranslation} from 'react-i18next';

const IndexPage = () => {
    
    const refNrId = useQuery().get('refnr_id');
    const {t} = useTranslation();

    function useQuery() {
        return new URLSearchParams(window.location.search);
    }


    return (
        <>
            { (refNrId !== null && refNrId !== undefined) ?
                <Redirect to={"/geolocation/" + refNrId} />
                :
                <>
                    <p style={{color: 'red'}}>
                        {t('chromiumWarning')}
                    </p>
                    <p>
                        {t('generalInfo1')}<br />
                        {t('generalInfo2')} (<a className="link" href="https://www.riigiteataja.ee/akt/128102011003" target="_blank" rel="noreferrer">https://www.riigiteataja.ee/akt/128102011003</a>).
                    </p>
                    <p>
                        {t('generalInfo3')}<br />
                        {t('generalInfo4')}
                    </p>
                    <p>
                        {t('generalInfoList')}:<br />
                        <ol>
                            <li>
                                {t('generalInfoListItem1')}
                            </li>
                            <li>
                                {t('generalInfoListItem2')}
                            </li>
                            <li>
                                {t('generalInfoListItem3')}
                            </li>
                            <li>
                                {t('generalInfoListItem4')}
                            </li>
                            <li>
                                {t('generalInfoListItem5')}
                            </li>
                        </ol>
                        {t('generalInfo5')}
                    </p>
                    <p>
                        {t('generalInfoContacts1')}
                        <br />
                        {t('generalInfoContacts2')}
                        <br />
                        <br />
                        {t('generalInfoContacts3')}
                    </p>
                </>
            }
        </>
    );

}

export default IndexPage;

